import { render, staticRenderFns } from "./ComplaintsContent.vue?vue&type=template&id=10a3c8cc&scoped=true&"
import script from "./ComplaintsContent.vue?vue&type=script&lang=js&"
export * from "./ComplaintsContent.vue?vue&type=script&lang=js&"
import style0 from "./ComplaintsContent.vue?vue&type=style&index=0&id=10a3c8cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a3c8cc",
  null
  
)

export default component.exports